// AI Generated Component
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'policy-exchange-center-labels',
    standalone: false,
    template: `
        <div class="policy-exchange-center-labels">
            <ul class="list-inline" *ngFor="let labelItem of labelItems">
                <li *ngFor="let item of labelItem.items; index as index" class="label-item text-nowrap mr-2 mt-1">
                    <span class="pr-1">{{labelItem.labelGroup}}: {{item.name}}</span>
                    <span (click)="onCloseLabelClick(labelItem.labelGroup, index)"
                          [attr.aria-label]="getLabelCloseTranslation(labelItem.labelGroup, item.name)"
                          class="fa-fw fas fa-times-circle">
                    </span>
                </li>
            </ul>
        </div>
    `,
})
export class PolicyExchangeCenterLabelsComponent implements OnChanges {
    @Input() labels: any;
    @Output() onCloseLabel = new EventEmitter<any>();

    labelItems: any[] = [];

    constructor (private translateService: TranslateService) {}

    ngOnChanges (changes: SimpleChanges): void {
        const labelsValue = (changes.labels && changes.labels.currentValue) || undefined;
        if (labelsValue) {
            this.labelItems = [];
            Object.keys(labelsValue).forEach((key) => {
                this.labelItems.push({
                    labelGroup: key,
                    items: labelsValue[key],
                });
            });
        }
    }

    onCloseLabelClick (group: string, index: number): void {
        this.onCloseLabel.emit({ group, index });
    }

    getLabelCloseTranslation (groupName: string, labelName: string): string {
        const scopes = {
            groupName: groupName,
            labelName: labelName,
        };
        return this.translateService.getString('Close [[groupName]]: [[labelName]]', scopes);
    }
}
